import jQuery from "jquery";

import type { ISnippet as ICodeSnippet } from "../Header.ts";

const SNIPPET_REGISTRY: Record<string, Record<string, ICodeSnippet>> = {};

/**
 * @param name Identifier of the snippet library.
 * @param snippets Snippets to be added. An object with the snippet key and the snippet data.
 */
export function registerSnippetLib(name: string, snippets: Record<string, ICodeSnippet>): void {
  SNIPPET_REGISTRY[name] = jQuery.extend({}, SNIPPET_REGISTRY[name] ?? {}, snippets);
}

/**
 * @param name Name of the snippets to fetch.
 * @returns The snippets registered for the given name, or an empty object if no snippets exist.
 */
export function getSnippets(name: string): Record<string, ICodeSnippet> {
  return SNIPPET_REGISTRY[name] ?? {};
}
